import React from 'react'
import { FieldValues, useController } from 'react-hook-form'

import { Checkbox } from '../CheckboxSMB'
import { CheckboxControlledProps } from './types'

export const CheckboxControlled = <T extends FieldValues>(props: CheckboxControlledProps<T>) => {
  const { control, name, changeHandler, handleBlur, ...rest } = props

  const {
    field: { value, onChange, onBlur },
    fieldState: { invalid, error },
  } = useController({
    name,
    control,
  })

  const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked
    onChange(newValue)
    changeHandler?.(newValue)
  }

  const fieldBlurHandler = () => {
    onBlur()
    handleBlur?.()
  }

  return (
    <Checkbox
      checked={!!value}
      onChange={fieldChangeHandler}
      onBlur={fieldBlurHandler}
      error={invalid}
      errorMessage={error?.message}
      {...rest}
    />
  )
}
